// src/pages/SharedPresentationView.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { useTranslation } from 'react-i18next';
import { ARTKIV_APP_URL } from '../config/domains';

const SharedPresentationView = () => {
  const { session_token } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const [loading, setLoading] = useState(true);
  const [errorKey, setErrorKey] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    validateAndRedirect();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session_token]);

  const validateAndRedirect = async () => {
    try {
      setLoading(true);
      setErrorKey(null);

      console.log('[SharedPresentation] Validation token:', session_token);

      // Valider le session token
      const { data, error: validateError } = await supabase
        .rpc('validate_session_token', {
          p_session_token: session_token
        });

      if (validateError) {
        console.error('[SharedPresentation] Erreur validation:', validateError);
        throw validateError;
      }

      if (!data || data.length === 0) {
        throw new Error('invalid_token');
      }

      const validation = data[0];

      console.log('[SharedPresentation] Résultat validation:', validation);

      if (!validation.is_valid) {
        if (validation.expires_at && new Date(validation.expires_at) < new Date()) {
          setErrorKey("expired");
        } else {
          setErrorKey("invalid");
        }
        setLoading(false);
        return;
      }

      // Logger la vue
      try {
        await supabase.rpc('log_presentation_view', {
          p_session_token: session_token,
          p_collection_id: validation.collection_id,
          p_artwork_id: null
        });
      } catch (logErr) {
        console.warn('[SharedPresentation] Erreur log (non bloquant):', logErr);
      }

      // Rediriger vers le mode présentation
      console.log('[SharedPresentation] Redirection vers:', validation.collection_id);
      
      // Stocker le session_token dans sessionStorage pour les policies RLS
      sessionStorage.setItem('presentation_session_token', session_token);
      
      navigate(`/presentation/collection/${validation.collection_id}`);

    } catch (err) {
      console.error('[SharedPresentation] Erreur:', err);
      setErrorKey("generic");
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: 'Georgia, serif',
        background: '#000000',
        color: '#ffffff'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid rgba(255, 255, 255, 0.3)',
          borderTop: '3px solid #ffffff',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <p style={{ marginTop: '24px', fontSize: '18px' }}>
          {t('sharedPresentation.loading')}
        </p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (errorKey) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontFamily: 'Georgia, serif',
        background: '#000000',
        color: '#ffffff',
        padding: '40px'
      }}>
        <div style={{
          fontSize: '64px',
          marginBottom: '32px',
          opacity: '0.5'
        }}>
          ⚠️
        </div>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '400',
          marginBottom: '16px',
          textAlign: 'center',
          letterSpacing: '-0.02em'
        }}>
          {t('sharedPresentation.accessDenied')}
        </h1>
        <p style={{
          fontSize: '16px',
          color: 'rgba(255, 255, 255, 0.7)',
          textAlign: 'center',
          maxWidth: '500px',
          lineHeight: '1.6',
          marginBottom: '32px'
        }}>
          {t(`sharedPresentation.errors.${errorKey}`)}
        </p>
        <button
          onClick={() => window.location.href = ARTKIV_APP_URL}
          style={{
            padding: '14px 32px',
            background: '#ffffff',
            color: '#000000',
            border: 'none',
            borderRadius: '2px',
            fontSize: '15px',
            fontWeight: '500',
            cursor: 'pointer',
            fontFamily: 'system-ui, sans-serif',
            transition: 'transform 0.2s ease'
          }}
          onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
          onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
        >
          {t('sharedPresentation.backToArtkiv')}
        </button>
      </div>
    );
  }

  return null;
};

export default SharedPresentationView;